/**
 * components/Toast/types.ts
 * The four tones a toast can carry. `plain` is the default — a white left
 * border, used for state changes that are neither good nor bad news
 * ("Rule updated.").
 */
export type ToastTone = 'success' | 'danger' | 'warn' | 'plain';

/** react-native-toast-message dispatches by `type`, so the tone IS the type. */
export const TOAST_TYPES: readonly ToastTone[] = ['success', 'danger', 'warn', 'plain'];
